import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { fileAttachType, FrameType } from 'core/structs/DrawType'

// Define a type for the slice state
interface drawState {
  isOpenDraw: boolean
  frames: {
    [page: number]: FrameType[]
  }
}

// Define the initial state using that type
const initialState: drawState = {
  isOpenDraw: false,
  frames: {}
}

export const drawSlice = createSlice({
  name: 'draw',
  initialState,
  reducers: {
    setStatusDraw: (state, action: PayloadAction<any>) => {
      state.isOpenDraw = action.payload.status
    },
    addFrame: (state, action: PayloadAction<{ page: number; frame: FrameType }>) => {
      if (!state.frames[action.payload.page]) {
        state.frames[action.payload.page] = []
      }
      if (action.payload.frame.actionId) {
        if (!state.frames[action.payload.page].some((frameState) => frameState.actionId === action.payload.frame.actionId)) {
          state.frames[action.payload.page].push(action.payload.frame)
        }
      } else if (!state.frames[action.payload.page].some((frameState) => frameState.id === action.payload.frame.id)) {
        state.frames[action.payload.page].push(action.payload.frame)
      }
    },

    updateFrame: (
      state,
      action: PayloadAction<{
        page: number
        frame: {
          id: string
          width?: number
          height?: number
          x?: number
          y?: number
          type?: fileAttachType
          attached?: boolean
          actionId?: number
          url?: string,
          scale?: number,
          file_name?: string
        }
      }>
    ) => {
      if (!state.frames[action.payload.page]) {
        state.frames[action.payload.page] = []
      }
      state.frames[action.payload.page] = state.frames[action.payload.page].map((frame) =>
        frame.id === action.payload.frame.id
          ? {
            ...frame,
            ...action.payload.frame
          }
          : frame
      )
    },
    removeFrame: (state, action: PayloadAction<{ page: number; id: string }>) => {
      if (!state.frames[action.payload.page]) {
        state.frames[action.payload.page] = []
      }
      state.frames[action.payload.page] = state.frames[action.payload.page].filter((frame) => frame.id !== action.payload.id)
    },
    removeAllFrame: (state) => {
      state.frames = {}
    }
  }
})
export const { setStatusDraw, addFrame, updateFrame, removeFrame, removeAllFrame } = drawSlice.actions

export default drawSlice.reducer
